import { getJson } from "./client";

// /api/version — paim package versions for the portal + operator pods.
// Drives the small badge in the SPA header so operators can see at-a-
// glance which image tag each Deployment is running, and notice
// mid-rollout drift between the two.

export interface VersionResponse {
  portal_version: string;
  // "unreachable" when the operator pod isn't up (rolling restart),
  // or "http <status>" when it returned a non-200. Render verbatim;
  // the user knowing "operator unreachable" is the point.
  operator_version: string;
}

export function getVersions(): Promise<VersionResponse> {
  return getJson<VersionResponse>("/api/version");
}
